import {
  Box,
  Card,
  CardContent,
  Divider,
  Grid,
  Typography,
  useTheme,
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Person } from '@mui/icons-material';
import { OccupancyDTO } from '@bandido/shared/dtos';
import { RoomDTO } from '@bandido/shared/dtos/clients/get-saleorder.dto';
import { getExactAgeForDOB } from '@frontend/features/common/helper';

interface HotelDetailProps {
  rooms: RoomDTO[];
  occupancies: OccupancyDTO[];
  checkoutDate: string;
}

export const SaleOrderHotelRooms = ({ rooms, occupancies, checkoutDate }: HotelDetailProps) => {
  const { t } = useTranslation();
  const theme = useTheme();
  return (
    <Card variant="outlined">
      <CardContent
        sx={{
          background: theme.palette.paper.dark
        }}
      >
        <Box display="flex" flexDirection="column" gap={2}>
          <Typography variant="subtitle1">
            {t('saleOrder.view.rooms.title', { rooms: rooms.length })}
          </Typography>
          <Divider/>
          {
            rooms.map((room) => {
              const roomOccupancy = occupancies.find(({ id }) => id === room.occupancyRefId);
              return (
                <>
                  <Typography variant="subtitle2">
                    {`${room.description} (${room.code})`}
                  </Typography>
                  {
                    roomOccupancy?.paxes.map(({ dob = '', name, surname, title }, idx) => (
                      <Grid container alignItems="center" key={idx}>
                        <Grid item xs={6}>
                          <Typography variant="body2">
                            {t('saleOrder.view.rooms.paxName')}
                          </Typography>
                          <Box display="flex" alignItems="center" gap={1}>
                            <Person fontSize="small" sx={{ color: theme.palette.text.secondary }}/>
                            <Typography variant="body2">{`${title || ''} ${name} ${surname}`}</Typography>
                          </Box>
                        </Grid>
                        <Grid item xs={6}>
                          <Typography variant="body2">
                            {t('saleOrder.view.rooms.paxAge')}
                          </Typography>
                          <Box display="flex" alignItems="center" gap={1}>
                            <Typography variant="body2">{getExactAgeForDOB(dob, checkoutDate)}</Typography>
                          </Box>
                        </Grid>
                      </Grid>
                    ))
                  }
                </>
              );
            })
          }
        </Box>
      </CardContent>
    </Card>
  );
};
